import type { CalculatorPluginMeta } from "@/lib/plugins/calculator/types";

export const calculatorPlugin: CalculatorPluginMeta = {
  id: "engineering-calculator",
  name: "工程计算器",
  dynamicType: "fastener-calculator",
  category: "动态内容",
  routes: {
    zh: "/calculator",
    en: "/en/calculator",
  },
};

export function calculatorPluginPlaceholderHtml() {
  return `
    <section class="rt-section calculator-plugin-section">
      <div class="rt-section-head">
        <span class="rt-eyebrow">工程计算器</span>
        <h2>紧固件在线计算器</h2>
        <p>前台会渲染真实工程计算器插件，包含单位换算、扭矩、底孔、硬度、强度校核等 10 个计算器。</p>
      </div>
      <div data-rt-dynamic="fastener-calculator" data-plugin-id="engineering-calculator" class="calculator-plugin-placeholder">
        <article><strong>单位换算</strong><span>Metric / Inch</span></article>
        <article><strong>拧紧扭矩</strong><span>Torque</span></article>
        <article><strong>强度校核</strong><span>Strength Check</span></article>
      </div>
    </section>
  `;
}
